import React from "react";
import { useTranslation } from "react-i18next";

export default function HeaderThree({ menuItemsThree, tab, setTab }) {
  const { t } = useTranslation();

  const handleClickTab = (tabName) => {
    setTab(tabName);
  };

  return (
    <div className="living-navigation">
      <div className="bostami-main-menu-wrap">
        <nav
          className="bastami-main-menu main_menu_3"
          aria-label={t("app.navegacionPrincipal")}
        >
          <ul>
            {menuItemsThree.map((elm) => (
              <li key={elm.id} className={tab === elm.tab ? "active" : ""}>
                <button
                  type="button"
                  className="menu-item-content"
                  onClick={() => handleClickTab(elm.tab)}
                  aria-pressed={tab === elm.tab}
                >
                  <span className="icon">
                    <i className={elm.icon} aria-hidden="true"></i>
                  </span>
                  <span className="text">{elm.text}</span>
                </button>
              </li>
            ))}
          </ul>
        </nav>
      </div>
    </div>
  );
}
